import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { URLSearchParams } from "@angular/http";
import { environment } from "../../../environments/environment";

export class EditaisFiltro {
  titulo: string;
  entidadeConcedente: any;
  tipoEdital: string;
  pagina = 0;
  itensPorPagina = 10;
}

@Injectable( )
export class EditaisService {
  apiUrl = environment.apiUrl;

  constructor(private http: Http) {}

  buscarPorCodigo(codigo: number): Promise<any> {
    return this.http
      .get(`${this.apiUrl}/chamamento-publico/pesquisa-publica/${codigo}`)
      .toPromise()
      .then((response) => response.json());
  }

  pesquisarChamamento(filtro: EditaisFiltro): Promise<any> {
    const params = new URLSearchParams();

    params.set("page", filtro.pagina.toString());
    params.set("size", filtro.itensPorPagina.toString());

    if (filtro.titulo) {
      params.set("titulo", filtro.titulo);
    }
    if (filtro.entidadeConcedente) {
      params.set("entidadeConcedente", filtro.entidadeConcedente);
    }

    return this.http
      .get(`${this.apiUrl}/chamamento-publico/pesquisa-publica`, {
        search: params,
      })
      .toPromise()
      .then((response) => {
        return response.json();
      });
  }

  pesquisarCredenciamento(filtro: EditaisFiltro): Promise<any> {
    const params = new URLSearchParams();

    params.set('page', filtro.pagina.toString());
    params.set('size', filtro.itensPorPagina.toString());

    if (filtro.titulo) {
      params.set('titulo', filtro.titulo);
    }
    if (filtro.entidadeConcedente) {
      params.set('entidadeConcedente', filtro.entidadeConcedente);
    }
    if (filtro.tipoEdital) {
      params.set('tipoEdital', filtro.tipoEdital);
    }

    return this.http.get(`${this.apiUrl}/editais-credenciamento/pesquisa-publica/filtro`, { search: params })
      .toPromise()
      .then(response => {
        return response.json();
      })
  }
}
